import { Grid, Link, Theme, Typography, useMediaQuery } from '@quillbot/design-system';
import React from 'react';
import { getCgBreakpointDown } from '../utils';

const Info = () => {
  const isSmallScreen = useMediaQuery<Theme>((theme) => getCgBreakpointDown(theme));

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
      style={{
        marginBottom: '50px',
      }}
    >
      <Grid
        item
        container
        justifyContent="center"
        alignItems="center"
        style={{
          padding: isSmallScreen ? '60px 0px 30px' : '60px 0px 36px',
          textAlign: isSmallScreen ? 'center' : undefined,
        }}
      >
        <Typography
          component="h1"
          style={{
            fontSize: '30px',
            fontWeight: 400,
          }}
        >
          Cite Smarter, Faster, and Easier
        </Typography>
      </Grid>

      <Grid item style={{ maxWidth: '725px' }}>
        <Typography
          component="h1"
          style={{
            fontSize: '16px',
            textAlign: 'center',
            padding: isSmallScreen ? '0px 20px' : '',
          }}
        >
          Easily create APA, MLA, and Chicago style full and in-text citations in a snap. Our free
          Citation Generator is a fast, reliable way to make citations for your&nbsp;
          <Link href="https://quillbot.com/blog/quillbots-guide-to-essay-writing/" target="_blank">
            <a>essays</a>
          </Link>
          , presentations, and other projects.
        </Typography>
      </Grid>

      <Grid item>
        <img
          src="/images/coWriter/citation-quilly.svg"
          alt="citation-quilly"
          style={{ margin: '20px 0' }}
        />
      </Grid>

      <Grid item style={{ maxWidth: '725px' }}>
        <Typography
          style={{
            fontSize: '16px',
            textAlign: 'center',
            padding: isSmallScreen ? '0px 20px' : '',
          }}
        >
          We also provide information about citing different types of reference materials in
          different formats, so you can learn the skills you need to succeed and have the support of
          a robust tool whenever you need it.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Info;
